/** Élan du geste au lâcher (sert à la force du lancer). */
export const PHYS = {
  maxSpeed: 3.4,      // px/ms : au-delà, un geste n'ajoute plus d'élan
  window: 90,         // ms de geste prises en compte pour la vitesse au lâcher
};

/** Vitesse au lâcher (px/ms) d'après les derniers points du geste. */
export function releaseVelocity(samples) {
  if (samples.length < 2) return { vx: 0, vy: 0 };
  const last = samples[samples.length - 1];
  let first = samples[0];
  for (let i = samples.length - 2; i >= 0; i -= 1) {
    first = samples[i];
    if (last.t - samples[i].t >= PHYS.window) break;
  }
  const dt = Math.max(last.t - first.t, 8);
  let vx = (last.x - first.x) / dt;
  let vy = (last.y - first.y) / dt;
  const speed = Math.hypot(vx, vy);
  if (speed > PHYS.maxSpeed) { vx *= PHYS.maxSpeed / speed; vy *= PHYS.maxSpeed / speed; }
  return { vx, vy };
}
